import React from 'react'

export default ({ children, className, ...props }) => (
    <button className={className} {...props}>
        { children }
    </button>
)
